'use strict';
var parent = require('../../es/instance/map');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/map.js
// module id = 765
// module chunks = 13